import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';

import Layout from './components/Layout';
import HomePage from './pages/HomePage';
import NotFoundPage from './pages/NotFoundPage';
import RulesPage from './pages/RulesPage';
import TermsPage from './pages/TermsPage';
import PrivacyPage from './pages/PrivacyPage';
import JoinRedirectPage from './pages/JoinRedirectPage';
import AdminLoginPage from './pages/admin/AdminLoginPage';
import AdminDashboardPage from './pages/admin/AdminDashboardPage';
import ProtectedAdminRoute from './components/admin/ProtectedAdminRoute';
import { AdminAuthProvider } from './contexts/AdminAuthContext';

import theme from './theme';
import './index.css';

const App: React.FC = () => {
  return (
    <StyledThemeProvider theme={theme}>
      <AdminAuthProvider>
        <Routes>
          {/* Admin routes - no Layout wrapper */}
          <Route path="/admin" element={<AdminLoginPage />} />
          <Route
            path="/admin/dashboard"
            element={
              <ProtectedAdminRoute>
                <AdminDashboardPage />
              </ProtectedAdminRoute>
            }
          />
          
          {/* Public routes with Layout */}
          <Route path="/" element={<Layout><HomePage /></Layout>} />
          <Route path="/rules" element={<Layout><RulesPage /></Layout>} />
          <Route path="/terms" element={<Layout><TermsPage /></Layout>} />
          <Route path="/privacy" element={<Layout><PrivacyPage /></Layout>} />
          <Route path="/join/:code" element={<Layout><JoinRedirectPage /></Layout>} />
          <Route path="*" element={<Layout><NotFoundPage /></Layout>} />
        </Routes>
      </AdminAuthProvider>
    </StyledThemeProvider>
  );
};

export default App;
